import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useCreateUserWithEmailAndPassword } from 'react-firebase-hooks/auth';
import {useLocation, useNavigate } from 'react-router-dom';
import auth from '../../firebase.init';
import BtnLink from '../CustomLink/BtnLink'

const SignUp = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '/';
    const [createUserWithEmailAndPassword, user] = useCreateUserWithEmailAndPassword(auth)

    const handleEmailBlur = event =>{
        setEmail(event.target.value);
    }

    const handlePasswordBlur = event =>{
        setPassword(event.target.value);
    }

    const handleConfirmPasswordBlur = event =>{
        setConfirmPassword(event.target.value);
    }

    if(user){
        navigate(from, {replace: true});
    }

    const handleCreateUser = event =>{
        event.preventDefault();
        if(password !== confirmPassword){
            setError('Your two passwords did not match');
            return;
        }
        if(password.length <6){
            setError('Password must be 6 characters or longer');
            return;
        }
        
        createUserWithEmailAndPassword(email, password);
    }



    return (
        <div className='container'>
            <h2>SignUp</h2>
            <div className='mx-auto w-50'>
                <Form onSubmit={handleCreateUser}>
                    <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control required type="text" placeholder="Enter Full Name" />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Email address</Form.Label>
                        <Form.Control  onBlur={handleEmailBlur} required type="email" placeholder="Enter email" />
                        <Form.Text className="text-muted">
                            We'll never share your email with anyone else.
                        </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>
                        <Form.Control onBlur={handlePasswordBlur} required type="password" placeholder="Password" />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Confirm-Password</Form.Label>
                        <Form.Control onBlur={handleConfirmPasswordBlur} required type="password" placeholder="Confirm-Password" />
                    </Form.Group>

                    <p style={{color: 'red'}}>{error}</p>

                    <Button variant="primary" type="submit">
                        Sign Up
                    </Button>
                </Form>
                <span> Have you already an Account? Please <BtnLink to="/login">Log In Now</BtnLink> </span>
            </div>
        </div>
    );
};

export default SignUp;